import { useEffect, useState } from 'react'

/**
 * Returns a relative-time string like "há 28s" / "há 5min" / "há 2h",
 * re-rendering once a second so it feels live without polling. The
 * absolute timestamp from the API is the source of truth; ``'—'`` when
 * it's missing or unparseable.
 */
export function useRelativeTime(iso: string | null | undefined): string {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now())
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])
  if (!iso) return '—'
  const then = new Date(iso).getTime()
  if (!Number.isFinite(then)) return '—'
  const seconds = Math.max(0, Math.floor((now - then) / 1000))
  if (seconds < 60) return `há ${String(seconds)}s`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `há ${String(minutes)}min`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `há ${String(hours)}h`
  const days = Math.floor(hours / 24)
  return `há ${String(days)}d`
}
